import React, { useState, useEffect } from 'react';
import './Style/AllUsers.css'; // Create this CSS file
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';
import UsePaymentItems from './UsePaymentItems';

const PaymentItems = () => {
    const { paymentItems, paidItemLoading } = UsePaymentItems();

    // If loading, show loading component
    if (paidItemLoading) {
        return <Loading />;
    }

    return (
        <div className="all-user-data-container">
            <div className="user-data-content-wrapper">
                <TopNavbar name="All Users Data" />

                <div className="user-data-card">
                    <h2 className="user-data-title">All Users Information</h2>

                    <div className="table-responsive">
                        <table className="user-data-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>About</th>
                                    <th>Valid</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Valid</th>

                                </tr>
                            </thead>
                            <tbody>
                                {paymentItems && paymentItems.length > 0 ? (
                                    paymentItems.slice().reverse().map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{item.id || 'N/A'}</td>
                                            <td>{item.name || 'N/A'}</td>
                                            <td>{item.price || 'N/A'}</td>
                                            <td>{item.about || 'N/A'}</td>
                                            <td>{item.valid || 'N/A'}</td>
                                            <td>{item.type || 'N/A'}</td>
                                            <td>{item.status || 'N/A'}</td>
                                            <td>{item.year || 'N/A'}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="no-data-message">
                                            No users found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="user-data-stats">
                        <p>Total Users: <strong>{paymentItems ? paymentItems.length : 0}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentItems;